import { api } from "./api";

/**
 * Modelos desde el panel.
 *
 * Todas las funciones de este archivo hacían `try { ... } catch { return null }`,
 * de modo que un 403, un fallo de validación o una caída de red llegaban a la
 * pantalla como `null` y se pintaban igual que "no hay resultados". Al no
 * distinguirse, una tabla vacía podía significar cuatro cosas distintas y
 * ninguna quedaba registrada. Ahora el error sube y lo cuenta quien lo pinta.
 */

export const fetchModelService = (params = {}) => api.get('/model/models', { params });

export const fetchModelByIdService = ({ id }) => api.get(`/model/${id}`);

/**
 * La sala, desde el lado de quien entra a verla.
 *
 * La sala se cargaba con la ficha del panel (`/model/{id}`), que lleva el
 * correo de la cuenta y la clave de emisión y solo puede pedirla quien
 * administra perfiles: al cliente le respondía 403 y la sala se quedaba en
 * blanco sin decir por qué.
 */
export const fetchRoomService = ({ id }) => api.get(`/model/${id}/room`);

export const fetchCreateModelService = (data) => api.post('/model/register', data);

export const fetchDeleteModelService = (modelId) => api.delete(`/model/unassign/${modelId}`);

export const fetchRefresTokenObsModelService = (modelId) =>
    api.get(`/model/refres-token/${modelId}`);

export const fetchUpdateModelAccountService = (modelId, data) =>
    api.put(`/model/${modelId}/account`, data);

export const fetchUploadFileModelService = (modelId, file) => {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('id', modelId);

    return api.post('/model/upload-img', formData);
};

/**
 * Aforo actual de un grupo de salas.
 *
 * Va aparte del listado porque caduca en segundos: la parrilla se pide una vez
 * y esto se refresca solo, sin volver a traer modelos ni miniaturas.
 *
 * Devuelve `{ available, viewers }`; `available` en false significa que el
 * servidor de sockets no contestó, no que las salas estén vacías.
 */
export const fetchRoomViewersService = async (ids = []) => {
    if (!ids.length) return { available: true, viewers: {} };

    return await api.get('/model/rooms/viewers', { params: { ids } });
};
